<script setup lang="ts">
import Header from "@/components/Header.vue";
import lightRight from "@/assets/light-right.svg";
import { useI18n } from "vue-i18n";
import { onMounted } from "vue";
import { webviewTitle } from "@/utils/starnest";
import { isStarNest } from "@/utils/starnest";
const { t } = useI18n();
const goBuy = () => {
  window.open(import.meta.env.VITE_MUSE_HOOTSWAP_LINK);
};

onMounted(()=>{
  if (isStarNest) {
    webviewTitle('MUSE')
  }else{
    document.title = 'MUSE'
  }
})
</script>

<template>
  <div class="intro-layout">
    <div class="intro-header">
      <Header bgColor="transparent" />
    </div>
    <div class="banner"></div>
    <div class="intro-list">
      <div class="intro-item">
        <div class="intro-title">{{ t("what") }}</div>
        <div class="intro-content">
          <div class="intro-second-title"></div>
          <div class="intro-text">
            {{ t("museIntro") }}
          </div>
        </div>
      </div>
      <div class="intro-item">
        <div class="intro-title">{{ t("museUse") }}</div>
        <div class="intro-content">
          <div class="intro-second-title">{{ t("copyrightStaking") }}</div>
          <div class="intro-text">
            {{ t("copyrightStaking1") }}
          </div>
          <div class="intro-second-title">{{ t("vote") }}</div>
          <div class="intro-text">
            {{ t("vote1") }}
          </div>
          <div class="intro-second-title">{{ t("product") }}</div>
          <div class="intro-text">
            {{ t("product1") }}
          </div>
          <div class="intro-second-title">{{ t("more") }}</div>
          <div class="intro-text">
            {{ t("more1") }}
          </div>
          <div class="intro-second-title">{{ t("activity") }}</div>
          <div class="intro-text">
            {{ t("activity1") }}
          </div>
        </div>
      </div>
      <div class="intro-item">
        <div class="intro-title">{{ t("how") }}?</div>
        <div class="intro-content mt10">
          <ul class="intro-text ul">
            <li>{{ t("how1") }}</li>
            <li>{{ t("how2") }}</li>
            <li>{{ t("how3") }}</li>
            <li class="light">
              <span class="flex-row-start-center"
                >{{ t("how4") }} 
                <!-- <img :src="lightRight" alt="" /> -->
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.intro-layout {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #071412;
  padding-bottom: 60px;
  .intro-header {
    position: sticky;
    width: 100%;
    z-index: 55;
    top: 0;
    padding: 0 16px;
    backdrop-filter: blur(6px);       /* 毛玻璃 */
  }
  .banner {
    width: 100%;
    aspect-ratio: 375 / 182;
    background: url(../../assets/muse-banner.png);
    background-size: contain;
    background-repeat: no-repeat;
  }
  .intro-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    gap: 24px;
    padding: 16px;
    .intro-item {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: flex-start;
      .intro-title {
        color: #fff;
        /* 15 med */
        font-family: Montserrat;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 160% */
      }
      .intro-content {
        &.mt10 {
          margin-top: 10px;
        }
        .intro-second-title {
          margin-top: 8px;

          color: #bbb;
          /* 13 sem */
          font-family: Montserrat;
          font-size: 13px;
          font-style: normal;
          font-weight: 600;
          line-height: 20px; /* 153.846% */
          margin-bottom: 4px;
        }
        .intro-text {
          color: #7c807e;

          /* 13-reg */
          font-family: Montserrat;
          font-size: 13px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px; /* 153.846% */
          &.ul {
            padding-left: 16px;
          }
          li {
            list-style: disc;
            &.light {
              color: #C294FF;
            }
          }
        }
      }
    }
  }
}
</style>
